import { createApi } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const appealsApi = createApi({
  reducerPath: 'appeals',

  // Використовуємо ту саму кастомну функцію baseQuery з рефрешем, 
  // передаючи базовий префікс для цього API (аналогічно до '/notifications')
  baseQuery: createBaseQueryWithReauth('/appeals'),

  tagTypes: ['Appeals'],

  endpoints: builder => ({
    getClientAppeals: builder.query({
      query: ({ page = 1 } = {}) => {
        const params = {
          page, // додаємо параметр page до запиту
        };
        return {
          url: '',
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Appeals'],
    }),
    deleteAppeals: builder.mutation({
      query: (id) => ({
        url: `/delete?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Appeals'],
    }),
  }),
});

export const {
  useGetClientAppealsQuery,
  useDeleteAppealsMutation
} = appealsApi;